import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { BsClock, BsPersonGear } from "react-icons/bs";
import CommonContext from "../../store/Common";

function readServiceFlag(commonValue, storageKey) {
  if (commonValue != null) return String(commonValue);
  return sessionStorage.getItem(storageKey);
}

function UserTab({ member, onClickLogout, unEvent }) {
  const common = useContext(CommonContext);
  const isCompany = window.$Global.checkAuth("특허회사", member.auth);
  const isInvestor = window.$Global.checkAuth("투자자", member.auth);
  const showBoard =
    readServiceFlag(common.board_service, "board_service") === "true";

  const hasHistoryAlarm = unEvent.historyAlarmCount > 0;
  const hasUnconfirmedEvent = unEvent.unConfirmEventCnt > 0;

  return (
    <div className="user_tab">
      <ul className="header_user_tab_ul">
        {unEvent.showHistoryAlarm && (
          <li className="header_user_tab_item">
            <Link
              to="/history/alarm"
              className={hasHistoryAlarm ? "is-active" : ""}
            >
              <BsClock size={16} />
              <span>히스토리 {unEvent.historyAlarmCount}건</span>
            </Link>
          </li>
        )}
        {!isInvestor &&
          !window.$Global.checkAuth("특허회사_발명자만", member.auth) && (
            <li className="header_user_tab_item">
              <Link
                to="/alarm"
                className={hasUnconfirmedEvent ? "is-active" : ""}
              >
                <i
                  className={
                    hasUnconfirmedEvent
                      ? "icon_notification_on"
                      : "icon_notification"
                  }
                />
                <span>{unEvent.unConfirmEventCnt}건</span>
              </Link>
            </li>
          )}
        {!isInvestor && showBoard && (
          <li className="header_user_tab_item">
            <Link to="/board/list">게시판</Link>
          </li>
        )}
        <li className="header_user_tab_item">
          <Link to="/mypage/info">마이페이지</Link>
        </li>
        {((!window.$Global.checkAuth("특허회사_발명자만", member.auth) &&
          !window.$Global.checkAuth("대리인_담당자만", member.auth)) ||
          isInvestor) && (
          <li className="header_user_tab_item">
            <Link
              to={
                isInvestor
                  ? "/manage/product"
                  : String(
                      member.auth ??
                        sessionStorage.getItem("auth") ??
                        sessionStorage.getItem("rank")
                    ) !== "19"
                  ? "/manage/inventor"
                  : "/manage/user?tab=5"
              }
            >
              <BsPersonGear size={18} />
              <span>관리자</span>
            </Link>
          </li>
        )}
        {isCompany && (
          <li className="header_user_tab_item">
            <Link to="/approval/list">결재</Link>
          </li>
        )}
        <li
          className="header_user_tab_item header_user_tab_item--logout"
          onClick={onClickLogout}
        >
          로그아웃
        </li>
      </ul>
    </div>
  );
}

export default UserTab;
